// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2eyPO","select":"Header_select__2XPTd","clinic":"Header_clinic__2x488"};